(ns dashboard.i18n.fr
  (:require
   [clojure.string :refer [capitalize]]
   [inflections.core :refer [pluralize plural]]))

(def fr
  {:yes "oui"
   :no "non"
   :none "Auccun"
   :time/hours "Heures"
   :time/day "Jour"
   :time/date "Date"
   :time/weekends "Weekends"
   :time/weekdays "Jour de la semaine"
   :time/today "Aujoud'hui"
   :time/tomorrow "Demain"
   :time/yesterday "Hier"
   :time/week "Semaine"
   :time/next-week "Semaine suivante"
   :time/previous-week "Semaine précédente"
   :time/month "Mois"
   :time/next-month "Mois suivant"
   :time/previous-month "Mois précédent"
   :time/year "Année"
   :time/day-of-week "Jour de la semaine"
   :time/day-of-month "Jour du mois"

   :action/actions "Actions"
   :action/sign-in "S'identifier"
   :action/sign-out "Se déconnecter"
   :action/save "Sauvegarder"
   :action/add "Ajouter"
   :action/change "Changer"
   :action/create "Créer"
   :action/edit "Modifier"
   :action/download "Télécharger"
   :action/upload "Envoyer"
   :action/previous "Précédent"
   :action/next "Suivant"
   :action/close "Fermer"
   :action/select "Choisir"
   :action/view "Voir"
   :action/join "Rejoindre"
   :action/decline "Décliner"
   :action/delete "Détruire"
   :action/export "Exporter"
   :action/message "Contacter"
   :action/search "Chercher"

   :notifications "Notifications"
   :settings "Réglages"
   :tags "Tags"})
